import { ActionReducerMap, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store'
import { ProfileState } from './user-profile/user-profile.state'
import { profileReducer } from './user-profile/user-profile.reducers'
import { AddressState } from './user-addresses/user-addresses.state'
import { addressReducer } from './user-addresses/user-addresses.reducers'
import { PaymentMethodsState } from './user-payment-methods/user-payment-methods.state'
import { paymentMethodsReducer } from './user-payment-methods/user-payment-methods.reducers'
import { CustomerInfoActions } from './user-profile/user-profile.actions'
import { ManageSubscriptionState } from './manage-subscription/store/manage-subscription.state'
import { manageSubscriptionReducer } from './manage-subscription/store/manage-subscriptions.reducers'

export enum PendingState {
  pending = 'pending',
  success = 'success',
  failed = 'failed',
}

export interface AccountState {
  profileState: ProfileState
  addressState: AddressState
  paymentMethodsState: PaymentMethodsState
  pending: PendingState
  manageSubscriptionState: ManageSubscriptionState
}

export const accountPendingReducer = createReducer(
  PendingState.pending,
  on(CustomerInfoActions.customerInfoLoad, (): PendingState => PendingState.pending),
  on(CustomerInfoActions.customerInfoFail, (): PendingState => PendingState.failed),
  on(CustomerInfoActions.customerInfoSuccess, (): PendingState => PendingState.success),
  on(CustomerInfoActions.c4LoginLoad, (): PendingState => PendingState.pending),
)

export const AccountReducers: ActionReducerMap<AccountState> = {
  profileState: profileReducer,
  addressState: addressReducer,
  paymentMethodsState: paymentMethodsReducer,
  pending: accountPendingReducer,
  manageSubscriptionState: manageSubscriptionReducer,
}

export const selectAccountState = createFeatureSelector<AccountState>('account')

export const selectCustomerPendingState = createSelector(
  selectAccountState,
  (state: AccountState): PendingState => state.pending,
)
